import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import { IconButton, Slider, Box } from "@mui/material";
import "./styles.css";

const CustomAudioPlayer = ({
  isPlaying,
  currentTime,
  duration,
  audioElementRef,
  handlePlayPause = () => {},
  handleTimeUpdate = () => {},
  handleSliderChange = () => {},
  formatTime = () => {},
  audioBlobForAudioPlayer,
  setDuration,
}) => {
  return (
    <Box className="custom-audio-player-container">
      {currentTime === duration ? (
        <IconButton onClick={handlePlayPause}>
          <PlayArrowIcon fontSize="medium" />
        </IconButton>
      ) : (
        <Box className="audio-player-icon">
          <IconButton onClick={handlePlayPause}>
            {isPlaying ? (
              <PauseIcon fontSize="medium" />
            ) : (
              <PlayArrowIcon fontSize="larmediumge" />
            )}
          </IconButton>
        </Box>
      )}
      <audio
        ref={audioElementRef}
        onDurationChange={(e) => {
          setDuration(e.currentTarget.duration);
        }}
        onTimeUpdate={(e) => {
          handleTimeUpdate(e);
        }}
        onLoadedMetadata={(e) => {
          e.currentTarget.currentTime = 1e101;
        }}
        autoPlay={isPlaying}
        preload="metadata"
      >
        <source
          src={URL.createObjectURL(audioBlobForAudioPlayer)}
          type="audio/wav"
        />
      </audio>
      <Box className="audio-slider">
        <Slider
          value={currentTime}
          max={duration}
          onChange={handleSliderChange}
          aria-label="Audio slider"
        />
      </Box>
      <Box className="duration">{formatTime(duration)}</Box>
    </Box>
  );
};

export default CustomAudioPlayer;
